import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-around;
  width: 100%;
`;

export default Wrapper;



// WEBPACK FOOTER //
// ./client/components/shared/SocialMediaLinks/Wrapper.js